import React,{useState} from 'react';
import { Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaUser, FaBars } from 'react-icons/fa';
import { useDispatch,useSelector } from "react-redux";
import {logout} from "../../../ReduxStore/UserStore"
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import ApplyLoanForm from "../../../Pages/ApplyLoanForm"
import UpdatePassword  from './UpdatePassword';
import ProfileInfo from "./ProfileInfo"
import { Modal, Button, Form } from 'react-bootstrap';
import styles from "./HeaderStyles.scss"
import SubscribePlanDetails from '../../../Pages/SubscribePlanDetails';
export default function Header({ toggleSidebar }) {
  const navigateTo = useNavigate()
  const userData = useSelector((state) => state.auth.user);
  const dispatch = useDispatch()
  const [modelOpen,SetModelOpen ] = useState(0)
  const currentPlan = _.get(userData, 'current_plan_id', );
  const logoutMe =()=>{
    const role = _.get(userData,"role_id")
    console.log(role)
    dispatch(logout())
    if([1,2].includes(role)){
      localStorage.setItem("role_id",0)
      navigateTo("/login")
      return;
    }
    localStorage.setItem("role_id",1)
    navigateTo("/customer-login")
  }
  const [loaded_from,setloaded_from] = useState('');
  const [OpenForm,setOpenForm] = useState(0)
  return (
    <div className="d-flex justify-content-between align-items-center p-10 bg-white border-bottom">

      <button
        className="btn btn-link d-md-none pdr-10" // Show only on small screens
        onClick={toggleSidebar}
      >
        <FaBars size="1.5em" />
      </button>

      <div className="h5 m-0 logo"> </div>

      <div className="d-flex align-items-center">
     
      {((_.get(userData,"role_id")==5 && OpenForm ==0) )&&<>
      
      {<button onClick={()=>{setloaded_from("APPLY_SUBSCRIPTION");setOpenForm(1); }} class="btn btn-primary cursor-pointer ms-2" style={{background:"#9b311c", border:"#9b311c"}}>{currentPlan ? "Upgrade Plan" : "Subscribe Plan"}</button>}
       <button 
        onClick={() => { setloaded_from("APPLY_LOAN"); setOpenForm(1); }} 
        className="btn btn-primary cursor-pointer ms-2 blinking-button"
        style={{background:"#9b311c", border:"#9b311c"}}
      >
        Apply Loan
      </button>
       
      </>
      }
       
        
        <Dropdown>
          <Dropdown.Toggle variant="link" id="dropdown-basic" className="d-flex align-items-center text-decoration-none">
            {(() => {
              
              const imageStyle = {
                position: 'absolute',
                top: '-8px',
                left: '2px',
                width: '20px',
                height: '20px',
                zIndex: 1
              };

              if (currentPlan === 1) {
                return <img 
                  src="https://img.icons8.com/color/48/cheap-2--v1.png" 
                  alt="basic-plan" 
                  style={imageStyle}
                />;
              } else if (currentPlan === 2) {
                return <img 
                  src="https://img.icons8.com/ultraviolet/40/cheap-2.png" 
                  alt="premium-plan" 
                  style={imageStyle}
                />;
              }
              return <img 
                src="https://img.icons8.com/deco-color/48/diamond.png" 
                alt="vip-plan" 
                style={imageStyle}
              />;
            })()}
            <FaUser size="1.5em" style={{ position: 'relative', zIndex: 2, color: "#9b311c" }} />
            <span className="ms-2 hidden-xs" style={{color: "#9b311c"}}>{_.get(userData,"name",'')}</span>
          </Dropdown.Toggle>

          <Dropdown.Menu>
          
          <Dropdown.Item   onClick={()=>{ SetModelOpen(2) }} >Profile</Dropdown.Item>
            <Dropdown.Item onClick={()=>{ SetModelOpen(1) }} >Change Password</Dropdown.Item>
            <Dropdown.Item onClick={logoutMe} href="/">Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      
      {modelOpen==1&&<>
      
      <UpdatePassword openUpdatepassword={modelOpen} SetOpenUpdatePassword={()=>SetModelOpen(0)}/>
      </>}
      {modelOpen==2&&<>
      
      <ProfileInfo  openUpdatePassword={modelOpen}  SetOpenUpdatePassword={()=>SetModelOpen(0)}/>
      </>
      }

    {( OpenForm ==1  &&( _.get(userData,"role_id")==5) )&& <>
        <Modal size="xl"  show={ OpenForm ==1} onHide={() => { setOpenForm(0)}} centered>
           <Modal.Header closeButton> <Modal.Title>
            {loaded_from=="APPLY_SUBSCRIPTION"?"Subscribe Plan":loaded_from=="APPLY_LOAN"?"Apply Loan":"" }
            </Modal.Title> </Modal.Header> 

          <Modal.Body style={{ height: '600px', overflowY: 'auto' }}>
            <SubscribePlanDetails />
            <ApplyLoanForm loaded_from={loaded_from} close_me={setOpenForm} selectUser={userData} />
          </Modal.Body>        
        </Modal>
         </> 
    }
     
    </div>
  );
}
